<table mat-table [dataSource]="roles" class="mat-elevation-z0">

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> {{ 'Name' | translate }} </th>
    <td mat-cell *matCellDef="let role"> {{ RoleType[role.name] | translate }} </td>
  </ng-container>

  <ng-container matColumnDef="visible">
    <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'Visible' | translate }}" class="center-text"><mat-icon>remove_red_eye</mat-icon></th>
    <td mat-cell *matCellDef="let role" class="center-text">
      <mat-checkbox [(ngModel)]="role.accessibility.visible" (change)="onChange(role.name, $event.checked, 'visible')" [disabled]="role.accessibility.editable === true && role.name != RoleType.INTERN"> </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="editable">
    <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'Editable' | translate }}" class="center-text"><mat-icon>edit</mat-icon></th>
    <td mat-cell *matCellDef="let role" class="center-text">
      <mat-checkbox [(ngModel)]="role.accessibility.editable" *ngIf="role.name != RoleType.INTERN" (change)="onChange(role.name, $event.checked, 'editable')"> </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="submittable">
    <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'Submition' | translate }}" class="center-text"><mat-icon>done_all</mat-icon></th>
    <td mat-cell *matCellDef="let role" class="center-text">
      <mat-checkbox [ngModel]="role.accessibility.submittable ?? true" *ngIf="role.name != RoleType.INTERN" (change)="onChange(role.name, $event.checked, 'submittable')"> </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let role">
      <button mat-icon-button matTooltip="{{ 'Delete' | translate }}" (click)="onRemoveRole(role.name)" *ngIf="type !== 'page'" [disabled]="!role.isActive || type === 'page'">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="guidable">
    <th mat-header-cell *matHeaderCellDef matTooltip="{{ 'Guidable' | translate }}" class="center-text"><mat-icon>info</mat-icon></th>
    <td mat-cell *matCellDef="let role" class="center-text">
      <span (click)="onClickGuidableCheckbox(role)">
        <mat-checkbox [checked]="role.guide != undefined && role.guide.length > 0" [disabled]="true"> </mat-checkbox>
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
  <tr mat-row *matRowDef="let role; columns: getDisplayedColumns()" [ngClass]="{'disabled': !role.isActive}"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
  </tr>
</table>


<div *ngIf="currentRole" class="cdc-form-field actif">
  <div class="cdc-label d-flex justify-content-between align-items-center">
    <span>
      {{ "Guide" | translate }}: {{ RoleType[currentRole.name] | translate }}
    </span>
    <mat-icon *ngIf="currentRole.guide != undefined && currentRole.guide.length > 0" style="font-size: 20px; cursor:pointer" matTooltip="{{ 'Clean' | translate }}" (click)="onClickCleanGuide()">cleaning_services</mat-icon>
  </div>
  <angular-editor #editorTextArea  [config]="config" [(ngModel)]="editorText"   (ngModelChange)="onEditorChange($event)"></angular-editor>
</div>
